import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum cotaConsorcieiServiceEnum {
  getErrors = "/errors",
  setPendency = "/pendency"
}

export default class CotaConsorcieiService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/cota-consorciei");
  }

  public getErrors = async () => await this.GET(cotaConsorcieiServiceEnum.getErrors);
  public setPendency = async (request: any) => await this.POST(cotaConsorcieiServiceEnum.setPendency, request);
}


// WEBPACK FOOTER //
// ./src/services/api/CotaConsorciei.service.ts